import { Injectable } from '@angular/core';
import { BoxxWebBrowserPickerOptions } from '@boxx/boxx-images';
import { BoxxImageConstraints, BoxxImageModel } from '../models/BoxxImage.model';

@Injectable()
export abstract class BoxxImagePickerTemplateMethod {
  protected pickerOptions: BoxxWebBrowserPickerOptions;

  protected imageConstraints: BoxxImageConstraints;

  private defaultImageConstraints: BoxxImageConstraints = {
    maxBytes: 5 * 1000 * 1000, // 5Mb max
    maxWidth: 0,
    maxHeight: 0,
    aspectRatio: 1,
  };

  constructor() {}

  async pickImages() {
    const sourceImages: BoxxImageModel[] = await this.getSourceImages();

    sourceImages.forEach(image => image.validate(this.imageConstraints));

    return sourceImages;
  }

  setImageConstraints(constraints: BoxxImageConstraints) {
    this.imageConstraints = { ...this.defaultImageConstraints, ...constraints };
    return this;
  }

  abstract setPickerOptions<T>(options: T): BoxxImagePickerTemplateMethod;

  abstract getSourceImages(): Promise<BoxxImageModel[]>;
}
